import api from './api';

const emailCampaignService = {
  // Template APIs
  getTemplates: async (params = {}) => {
    const response = await api.get('/email-campaigns/templates/', { params });
    return response.data;
  },

  getTemplate: async (id) => {
    const response = await api.get(`/email-campaigns/templates/${id}/`);
    return response.data;
  },

  createTemplate: async (data) => {
    const response = await api.post('/email-campaigns/templates/', data);
    return response.data;
  },

  updateTemplate: async (id, data) => {
    const response = await api.patch(`/email-campaigns/templates/${id}/`, data);
    return response.data;
  },

  deleteTemplate: async (id) => {
    const response = await api.delete(`/email-campaigns/templates/${id}/`);
    return response.data;
  },

  uploadTemplate: async (formData) => {
    const response = await api.post('/email-campaigns/templates/upload/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Campaign APIs
  getCampaigns: async (params = {}) => {
    const response = await api.get('/email-campaigns/campaigns/', { params });
    return response.data;
  },

  getCampaign: async (id) => {
    const response = await api.get(`/email-campaigns/campaigns/${id}/`);
    return response.data;
  },

  createCampaign: async (data) => {
    const response = await api.post('/email-campaigns/campaigns/', data);
    return response.data;
  },

  updateCampaign: async (id, data) => {
    const response = await api.patch(`/email-campaigns/campaigns/${id}/`, data);
    return response.data;
  },

  deleteCampaign: async (id) => {
    const response = await api.delete(`/email-campaigns/campaigns/${id}/`);
    return response.data;
  },

  prepareCampaign: async (id) => {
    const response = await api.post(`/email-campaigns/campaigns/${id}/prepare/`);
    return response.data;
  },

  sendCampaign: async (id) => {
    const response = await api.post(`/email-campaigns/campaigns/${id}/send/`);
    return response.data;
  },

  sendTestEmail: async (id, testEmail) => {
    const response = await api.post(`/email-campaigns/campaigns/${id}/send_test/`, {
      test_email: testEmail,
    });
    return response.data;
  },

  getCampaignRecipients: async (id, params = {}) => {
    const response = await api.get(`/email-campaigns/campaigns/${id}/recipients/`, { params });
    return response.data;
  },

  // Utility APIs
  previewFilter: async (filterCriteria) => {
    const response = await api.post('/email-campaigns/preview-filter/', {
      filter_criteria: filterCriteria,
    });
    return response.data;
  },

  getAvailableFilters: async () => {
    const response = await api.get('/email-campaigns/available-filters/');
    return response.data;
  },

  getStatistics: async () => {
    const response = await api.get('/email-campaigns/statistics/');
    return response.data;
  },
};

export default emailCampaignService;
